// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.home-container {
  width: 100%;
  overflow-x: hidden;
  padding-top: 60px;
}

/* Common Section Styles */
section {
  padding: 80px 20px;
  scroll-margin-top: 80px;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 3rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.section-subtitle {
  font-size: 1.3rem;
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* Hero Section */
.hero-section {
  min-height: 90vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  padding: 100px 20px;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.hero-text {
  z-index: 2;
}

.hero-title {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 30px;
  color: #1a1a1a;
}

.hero-highlight {
  color: #ba7a27;
  position: relative;
  display: inline-block;
}

.hero-subtitle {
  font-size: 1.4rem;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.6;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.cta-primary {
  padding: 18px 40px;
  font-size: 1.2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(186, 122, 39, 0.3);
}

.cta-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(186, 122, 39, 0.4);
  background: linear-gradient(135deg, #d6792c 0%, #ba7a27 100%);
}

.cta-secondary {
  padding: 18px 40px;
  font-size: 1.2rem;
  font-weight: 700;
  background: white;
  color: #ba7a27;
  border: 2px solid #ba7a27;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-secondary:hover {
  background: #ba7a27;
  color: white;
  transform: translateY(-2px);
}

.hero-image {
  position: relative;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-phone {
  height: 450px;
  width: auto;
  position: absolute;
  right: 20%;
  top: 0;
  z-index: 2;
  transform: rotate(5deg);
  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.2));
  animation: float 3s ease-in-out infinite;
}

.hero-laptop {
  height: 280px;
  width: auto;
  position: absolute;
  left: 10%;
  bottom: 20px;
  z-index: 1;
  transform: rotate(-5deg);
  filter: drop-shadow(0 15px 30px rgba(0,0,0,0.15));
  animation: float 3s ease-in-out infinite 1.5s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(5deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
}

/* Mission Section */
.mission-section {
  background: white;
}

.mission-content {
  max-width: 900px;
  margin: 0 auto;
}

.mission-text {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #444;
  margin-bottom: 25px;
  text-align: center;
}

.mission-highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 60px;
}

.highlight-card {
  background: #f8f9fa;
  padding: 35px;
  border-radius: 15px;
  text-align: center;
  transition: all 0.3s ease;
}

.highlight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.highlight-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.highlight-card h3 {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1a1a1a;
}

.highlight-card p {
  color: #666;
  line-height: 1.6;
}

/* What We Offer Section */
.offer-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.offer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 35px;
}

.offer-card {
  background: white;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.offer-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
}

.offer-number {
  font-size: 4rem;
  font-weight: 900;
  color: #ba7a27;
  opacity: 0.1;
  position: absolute;
  top: -10px;
  right: 20px;
  line-height: 1;
}

.offer-card h3 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1a1a1a;
  position: relative;
  z-index: 1;
}

.offer-card p {
  color: #666;
  line-height: 1.7;
  position: relative;
  z-index: 1;
}

/* Pricing Section */
.pricing-section {
  background: white;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
  max-width: 1000px;
  margin: 0 auto;
}

.pricing-card-free {
  background: white;
  padding: 50px;
  border-radius: 20px;
  color: #1a1a1a;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 3px solid #f0f0f0;
  position: relative;
  transition: all 0.3s ease;
}

.pricing-card-free:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
  border-color: #ba7a27;
}

.pricing-card-featured {
  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);
  padding: 50px;
  border-radius: 20px;
  color: white;
  text-align: center;
  box-shadow: 0 10px 40px rgba(186, 122, 39, 0.3);
  position: relative;
  transform: scale(1.05);
}

.pricing-card-featured:hover {
  transform: scale(1.08);
}

.pricing-badge {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255,255,255,0.3);
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 0.9rem;
  backdrop-filter: blur(10px);
}

.pricing-plan {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 20px;
}

.pricing-amount {
  margin: 30px 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  line-height: 1;
}

.currency {
  font-size: 2rem;
  font-weight: 700;
  margin-right: 5px;
  margin-top: 10px;
}

.price {
  font-size: 5rem;
  font-weight: 900;
}

.period {
  font-size: 1.5rem;
  margin-left: 8px;
  margin-top: 30px;
  opacity: 0.9;
}

.pricing-features {
  list-style: none;
  padding: 0;
  margin: 30px 0;
  text-align: left;
}

.pricing-features li {
  padding: 12px 0;
  font-size: 1.1rem;
  border-bottom: 1px solid rgba(255,255,255,0.2);
}

.pricing-card-free .pricing-features li {
  border-bottom: 1px solid rgba(0,0,0,0.1);
  color: #444;
}

.pricing-features li:last-child {
  border-bottom: none;
}

.pricing-cta {
  width: 100%;
  padding: 18px;
  font-size: 1.2rem;
  font-weight: 700;
  background: white;
  color: #ba7a27;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;
}

.pricing-cta:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
}

.pricing-cta-free {
  width: 100%;
  padding: 18px;
  font-size: 1.2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;
}

.pricing-cta-free:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 20px rgba(186, 122, 39, 0.4);
}

.pricing-note {
  margin-top: 20px;
  font-size: 0.95rem;
  opacity: 0.9;
  font-style: italic;
}

.pricing-card-free .pricing-note {
  color: #666;
}

/* How We Can Help Section */
.help-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.help-content {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 60px;
  margin-bottom: 60px;
}

.help-main h3 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.help-main p {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 40px;
}

.help-steps {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.help-step {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.step-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 800;
  flex-shrink: 0;
}

.step-content h4 {
  font-size: 1.3rem;
  margin-bottom: 8px;
  color: #1a1a1a;
}

.step-content p {
  color: #666;
  line-height: 1.6;
  font-size: 1rem;
  margin: 0;
}

.help-examples {
  background: white;
  padding: 35px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
}

.help-examples h4 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 25px;
  color: #1a1a1a;
}

.help-list {
  list-style: none;
  padding: 0;
}

.help-list li {
  padding: 12px 0;
  font-size: 1.1rem;
  color: #444;
  border-bottom: 1px solid #f0f0f0;
}

.help-list li:last-child {
  border-bottom: none;
}

.help-cta {
  text-align: center;
  padding: 60px 40px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.help-cta h3 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 30px;
  color: #1a1a1a;
}

/* Responsive Design */
@media (max-width: 968px) {
  .hero-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .hero-title {
    font-size: 3rem;
  }
  
  .hero-buttons {
    justify-content: center;
  }
  
  .hero-image {
    height: 400px;
  }
  
  .hero-phone {
    height: 350px;
    width: auto;
    right: 10%;
  }
  
  .hero-laptop {
    height: 220px;
    width: auto;
    left: 5%;
  }
  
  .help-content {
    grid-template-columns: 1fr;
  }
  
  .pricing-grid {
    grid-template-columns: 1fr;
    max-width: 600px;
  }
  
  .section-title {
    font-size: 2.5rem;
  }
}

@media (max-width: 600px) {
  section {
    padding: 60px 15px;
  }
  
  .hero-section {
    padding: 60px 20px;
    min-height: auto;
  }
  
  .hero-title {
    font-size: 2.2rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .hero-buttons {
    flex-direction: column;
  }
  
  .cta-primary, .cta-secondary {
    width: 100%;
    padding: 15px 30px;
    font-size: 1rem;
  }
  
  .hero-image {
    height: 300px;
  }
  
  .hero-phone {
    height: 280px;
    width: auto;
    right: 50%;
    transform: translateX(50%) rotate(5deg);
  }
  
  .hero-laptop {
    display: none;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1.1rem;
  }
  
  .mission-highlights, .offer-grid {
    grid-template-columns: 1fr;
  }
  
  .pricing-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .pricing-card-featured {
    padding: 35px 25px;
    transform: scale(1);
  }
  
  .pricing-card-free {
    padding: 35px 25px;
  }
  
  .price {
    font-size: 4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;AACnD;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Container */\n.home-container {\n  width: 100%;\n  overflow-x: hidden;\n  padding-top: 60px;\n}\n\n/* Common Section Styles */\nsection {\n  padding: 80px 20px;\n  scroll-margin-top: 80px;\n}\n\n.section-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.section-title {\n  font-size: 3rem;\n  font-weight: 800;\n  text-align: center;\n  margin-bottom: 20px;\n  color: #1a1a1a;\n}\n\n.section-subtitle {\n  font-size: 1.3rem;\n  text-align: center;\n  color: #666;\n  margin-bottom: 60px;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Hero Section */\n.hero-section {\n  min-height: 90vh;\n  display: flex;\n  align-items: center;\n  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);\n  padding: 100px 20px;\n}\n\n.hero-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: center;\n}\n\n.hero-text {\n  z-index: 2;\n}\n\n.hero-title {\n  font-size: 4rem;\n  font-weight: 800;\n  line-height: 1.2;\n  margin-bottom: 30px;\n  color: #1a1a1a;\n}\n\n.hero-highlight {\n  color: #ba7a27;\n  position: relative;\n  display: inline-block;\n}\n\n.hero-subtitle {\n  font-size: 1.4rem;\n  color: #666;\n  margin-bottom: 40px;\n  line-height: 1.6;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.cta-primary {\n  padding: 18px 40px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);\n  color: white;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(186, 122, 39, 0.3);\n}\n\n.cta-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(186, 122, 39, 0.4);\n  background: linear-gradient(135deg, #d6792c 0%, #ba7a27 100%);\n}\n\n.cta-secondary {\n  padding: 18px 40px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  background: white;\n  color: #ba7a27;\n  border: 2px solid #ba7a27;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cta-secondary:hover {\n  background: #ba7a27;\n  color: white;\n  transform: translateY(-2px);\n}\n\n.hero-image {\n  position: relative;\n  height: 500px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.hero-phone {\n  height: 450px;\n  width: auto;\n  position: absolute;\n  right: 20%;\n  top: 0;\n  z-index: 2;\n  transform: rotate(5deg);\n  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.2));\n  animation: float 3s ease-in-out infinite;\n}\n\n.hero-laptop {\n  height: 280px;\n  width: auto;\n  position: absolute;\n  left: 10%;\n  bottom: 20px;\n  z-index: 1;\n  transform: rotate(-5deg);\n  filter: drop-shadow(0 15px 30px rgba(0,0,0,0.15));\n  animation: float 3s ease-in-out infinite 1.5s;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0) rotate(5deg); }\n  50% { transform: translateY(-20px) rotate(5deg); }\n}\n\n/* Mission Section */\n.mission-section {\n  background: white;\n}\n\n.mission-content {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.mission-text {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  color: #444;\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.mission-highlights {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n  margin-top: 60px;\n}\n\n.highlight-card {\n  background: #f8f9fa;\n  padding: 35px;\n  border-radius: 15px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.highlight-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.highlight-icon {\n  font-size: 3rem;\n  margin-bottom: 20px;\n}\n\n.highlight-card h3 {\n  font-size: 1.3rem;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: #1a1a1a;\n}\n\n.highlight-card p {\n  color: #666;\n  line-height: 1.6;\n}\n\n/* What We Offer Section */\n.offer-section {\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n}\n\n.offer-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 35px;\n}\n\n.offer-card {\n  background: white;\n  padding: 40px 30px;\n  border-radius: 15px;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.08);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.offer-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 8px 30px rgba(0,0,0,0.15);\n}\n\n.offer-number {\n  font-size: 4rem;\n  font-weight: 900;\n  color: #ba7a27;\n  opacity: 0.1;\n  position: absolute;\n  top: -10px;\n  right: 20px;\n  line-height: 1;\n}\n\n.offer-card h3 {\n  font-size: 1.4rem;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: #1a1a1a;\n  position: relative;\n  z-index: 1;\n}\n\n.offer-card p {\n  color: #666;\n  line-height: 1.7;\n  position: relative;\n  z-index: 1;\n}\n\n/* Pricing Section */\n.pricing-section {\n  background: white;\n}\n\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 40px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.pricing-card-free {\n  background: white;\n  padding: 50px;\n  border-radius: 20px;\n  color: #1a1a1a;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  border: 3px solid #f0f0f0;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.pricing-card-free:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);\n  border-color: #ba7a27;\n}\n\n.pricing-card-featured {\n  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);\n  padding: 50px;\n  border-radius: 20px;\n  color: white;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(186, 122, 39, 0.3);\n  position: relative;\n  transform: scale(1.05);\n}\n\n.pricing-card-featured:hover {\n  transform: scale(1.08);\n}\n\n.pricing-badge {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: rgba(255,255,255,0.3);\n  padding: 8px 20px;\n  border-radius: 20px;\n  font-weight: 700;\n  font-size: 0.9rem;\n  backdrop-filter: blur(10px);\n}\n\n.pricing-plan {\n  font-size: 2rem;\n  font-weight: 800;\n  margin-bottom: 20px;\n}\n\n.pricing-amount {\n  margin: 30px 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  line-height: 1;\n}\n\n.currency {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-right: 5px;\n  margin-top: 10px;\n}\n\n.price {\n  font-size: 5rem;\n  font-weight: 900;\n}\n\n.period {\n  font-size: 1.5rem;\n  margin-left: 8px;\n  margin-top: 30px;\n  opacity: 0.9;\n}\n\n.pricing-features {\n  list-style: none;\n  padding: 0;\n  margin: 30px 0;\n  text-align: left;\n}\n\n.pricing-features li {\n  padding: 12px 0;\n  font-size: 1.1rem;\n  border-bottom: 1px solid rgba(255,255,255,0.2);\n}\n\n.pricing-card-free .pricing-features li {\n  border-bottom: 1px solid rgba(0,0,0,0.1);\n  color: #444;\n}\n\n.pricing-features li:last-child {\n  border-bottom: none;\n}\n\n.pricing-cta {\n  width: 100%;\n  padding: 18px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  background: white;\n  color: #ba7a27;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 20px;\n}\n\n.pricing-cta:hover {\n  transform: scale(1.05);\n  box-shadow: 0 5px 20px rgba(0,0,0,0.2);\n}\n\n.pricing-cta-free {\n  width: 100%;\n  padding: 18px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);\n  color: white;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 20px;\n}\n\n.pricing-cta-free:hover {\n  transform: scale(1.05);\n  box-shadow: 0 5px 20px rgba(186, 122, 39, 0.4);\n}\n\n.pricing-note {\n  margin-top: 20px;\n  font-size: 0.95rem;\n  opacity: 0.9;\n  font-style: italic;\n}\n\n.pricing-card-free .pricing-note {\n  color: #666;\n}\n\n/* How We Can Help Section */\n.help-section {\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n}\n\n.help-content {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 60px;\n  margin-bottom: 60px;\n}\n\n.help-main h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: #1a1a1a;\n}\n\n.help-main p {\n  font-size: 1.2rem;\n  color: #666;\n  line-height: 1.7;\n  margin-bottom: 40px;\n}\n\n.help-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.help-step {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.step-number {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.step-content h4 {\n  font-size: 1.3rem;\n  margin-bottom: 8px;\n  color: #1a1a1a;\n}\n\n.step-content p {\n  color: #666;\n  line-height: 1.6;\n  font-size: 1rem;\n  margin: 0;\n}\n\n.help-examples {\n  background: white;\n  padding: 35px;\n  border-radius: 15px;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.08);\n}\n\n.help-examples h4 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 25px;\n  color: #1a1a1a;\n}\n\n.help-list {\n  list-style: none;\n  padding: 0;\n}\n\n.help-list li {\n  padding: 12px 0;\n  font-size: 1.1rem;\n  color: #444;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.help-list li:last-child {\n  border-bottom: none;\n}\n\n.help-cta {\n  text-align: center;\n  padding: 60px 40px;\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n}\n\n.help-cta h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 30px;\n  color: #1a1a1a;\n}\n\n/* Responsive Design */\n@media (max-width: 968px) {\n  .hero-content {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n  \n  .hero-title {\n    font-size: 3rem;\n  }\n  \n  .hero-buttons {\n    justify-content: center;\n  }\n  \n  .hero-image {\n    height: 400px;\n  }\n  \n  .hero-phone {\n    height: 350px;\n    width: auto;\n    right: 10%;\n  }\n  \n  .hero-laptop {\n    height: 220px;\n    width: auto;\n    left: 5%;\n  }\n  \n  .help-content {\n    grid-template-columns: 1fr;\n  }\n  \n  .pricing-grid {\n    grid-template-columns: 1fr;\n    max-width: 600px;\n  }\n  \n  .section-title {\n    font-size: 2.5rem;\n  }\n}\n\n@media (max-width: 600px) {\n  section {\n    padding: 60px 15px;\n  }\n  \n  .hero-section {\n    padding: 60px 20px;\n    min-height: auto;\n  }\n  \n  .hero-title {\n    font-size: 2.2rem;\n  }\n  \n  .hero-subtitle {\n    font-size: 1.1rem;\n  }\n  \n  .hero-buttons {\n    flex-direction: column;\n  }\n  \n  .cta-primary, .cta-secondary {\n    width: 100%;\n    padding: 15px 30px;\n    font-size: 1rem;\n  }\n  \n  .hero-image {\n    height: 300px;\n  }\n  \n  .hero-phone {\n    height: 280px;\n    width: auto;\n    right: 50%;\n    transform: translateX(50%) rotate(5deg);\n  }\n  \n  .hero-laptop {\n    display: none;\n  }\n  \n  .section-title {\n    font-size: 2rem;\n  }\n  \n  .section-subtitle {\n    font-size: 1.1rem;\n  }\n  \n  .mission-highlights, .offer-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .pricing-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n  \n  .pricing-card-featured {\n    padding: 35px 25px;\n    transform: scale(1);\n  }\n  \n  .pricing-card-free {\n    padding: 35px 25px;\n  }\n  \n  .price {\n    font-size: 4rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
